/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import IconProps, { StyledG } from './IconProps';

function SearchIcon(props: IconProps) {
	const { color = 'antracite' } = props;

	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
			<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1" opacity="0.8">
				<StyledG color={color} fillRule="nonzero" transform="translate(-191 -29)">
					<g transform="translate(0 1)">
						<path d="M206.85 43.85c-.2.2-.523.2-.723 0l-2.842-2.842c.256-.226.497-.467.723-.723l2.842 2.842c.2.2.2.523 0 .723zm-8.846-1.842a7.004 7.004 0 110-14.009 7.004 7.004 0 010 14.01zm0-13.007a6.004 6.004 0 100 12.007 6.004 6.004 0 000-12.007z" />
					</g>
				</StyledG>
			</g>
		</svg>
	);
}

export default SearchIcon;
